module.exports = __webpack_public_path__ + "img/link.98f4f684.svg";